/* eslint-disable no-console */
/* eslint-disable no-useless-catch */
import httpService from "@/shared/http";
import { store } from "@/main";
import { pathOr } from "ramda";
import { generateApiUrl, generateLang } from "@/shared/utils";

export const getLocationPublicCombo = async (text = null) => {
  try {
    const url = generateApiUrl(["globalServices", "location_public"], [], {
      city: text,
    });
    const response = await httpService.get(url);
    const options = pathOr([], ["data", "data"], response);
    return { options };
  } catch (error) {
    throw error;
  }
};
export const getTermCombo = async (text = null, extraQueryString = null) => {
  try {
    const defaultQueryString = { search_txt: text };
    const queryString = extraQueryString
      ? { ...defaultQueryString, ...extraQueryString }
      : defaultQueryString;
    const url = generateApiUrl(
      ["globalServices", "term_combo"],
      [],
      queryString
    );
    const response = await httpService.get(url);
    let options = pathOr([], ["data", "data"], response);
    options = options.map((option) => {
      const id = pathOr("", ["id"], option);
      const caption = pathOr("", ["caption"], option);
      return { ...option, caption: `${id}- ${caption}` };
    });
    return { options };
  } catch (error) {
    throw error;
  }
};
export const getUserCombo = async (text = null) => {
  try {
    const url = generateApiUrl(["globalServices", "user_combo"], [], {
      search_txt: text,
    });
    const response = await httpService.get(url);
    let options = pathOr([], ["data", "data"], response);
    options = options.map((option) => {
      const name = pathOr("", ["name"], option);
      const nationalCode = pathOr("", ["national_code"], option);
      return {
        id: pathOr(null, ["code"], option),
        caption: `${name} - ${nationalCode}`,
      };
    });
    return { options };
  } catch (error) {
    throw error;
  }
};
export const getExerciseCombo = async (text = null) => {
  try {
    const url = generateApiUrl(["globalServices", "exercise_combo"], [], {
      search_txt: text,
    });
    const response = await httpService.get(url);
    const data = pathOr([], ["data", "data"], response);
    const options = data.map((option) => {
      const { id, name: caption } = option;
      return { id, caption };
    });
    return { options };
  } catch (error) {
    throw error;
  }
};
export const getIndicatorCombo = async (text = null) => {
  try {
    const url = generateApiUrl(["globalServices", "indicator_combo"], [], {
      search_txt: text,
    });
    const response = await httpService.get(url);
    const options = pathOr([], ["data", "data"], response);
    return { options };
  } catch (error) {
    throw error;
  }
};
export const getEvidenceCombo = async (text = null) => {
  try {
    const url = generateApiUrl(["globalServices", "evidence_combo"], [], {
      search_txt: text,
    });
    const response = await httpService.get(url);
    const data = pathOr([], ["data", "data"], response);
    const options = data.map((option) => {
      const { id, evidence: caption } = option;
      return { id, caption };
    });
    return { options };
  } catch (error) {
    throw error;
  }
};
export const getReportSettingCombo = async (resource = "") => {
  try {
    let queryString = { is_manual: 1 };
    if (resource) {
      queryString.resource = resource;
    }
    const url = generateApiUrl(
      ["globalServices", "report_settings_combo"],
      [],
      queryString
    );
    const response = await httpService.get(url);
    const options = pathOr([], ["data", "data"], response);
    return { options };
  } catch (error) {
    throw error;
  }
};
export const getWhatsNewVersionCombo = async (text = null) => {
  try {
    const url = generateApiUrl(["globalServices", "whats_new_version"], [], {
      search_txt: text,
    });
    const response = await httpService.get(url);
    const data = pathOr([], ["data", "data"], response);
    const options = data.map((option) => {
      const { id, version: caption, change_date: changeDate } = option;
      return { id, caption, changeDate };
    });
    return { options };
  } catch (error) {
    throw error;
  }
};
export const getCompanyCombo = async (text = null) => {
  try {
    const url = generateApiUrl(["globalServices", "company_combo"], [], {
      search_txt: text,
    });
    const response = await httpService.get(url);
    const data = pathOr([], ["data", "data"], response);
    const options = data.map((option) => {
      const { code: id, name: caption } = option;
      return { id, caption };
    });
    return { options };
  } catch (error) {
    throw error;
  }
};
export const getAzmoonExecuteCombo = async (text = null) => {
  try {
    const url = generateApiUrl(["globalServices", "azmoon_execute_combo"], [], {
      search_txt: text,
    });
    const response = await httpService.get(url);
    const data = pathOr([], ["data", "data"], response);
    const options = data.map((option) => {
      const { id, caption } = option;
      const newCaption = `${id} - ${caption}`;
      return { id, caption: newCaption };
    });
    return { options };
  } catch (error) {
    throw error;
  }
};
export const getRoleCombo = async (text = null) => {
  try {
    const url = generateApiUrl(["globalServices", "role_combo"], [], {
      search_txt: text,
    });
    const response = await httpService.get(url);
    const data = pathOr([], ["data", "data"], response);
    const options = data.map((option) => {
      const { code, caption } = option;
      return { id: code, caption };
    });
    return { options };
  } catch (error) {
    throw error;
  }
};
export const getTermStateCombo = async (text = null, extraQueryString = {}) => {
  try {
    const url = generateApiUrl(["globalServices", "termStateCombo"], [], {
      search_txt: text,
      ...extraQueryString,
    });
    const response = await httpService.get(url);
    const data = pathOr([], ["data", "data"], response);
    const options = data.map((option) => {
      const { state_name, state_caption } = option;
      return { id: state_name, caption: state_caption };
    });
    return { options };
  } catch (error) {
    throw error;
  }
};
export const getTermStateDefineCombo = async (
  text = null,
  extraQueryString = {}
) => {
  try {
    const url = generateApiUrl(["globalServices", "termStateDefineCombo"], [], {
      search_txt: text,
      ...extraQueryString,
    });
    const response = await httpService.get(url);
    const data = pathOr([], ["data", "data"], response);
    const options = data.map((option) => {
      const { state_name, state_caption } = option;
      return { id: state_name, caption: state_caption };
    });
    return { options };
  } catch (error) {
    throw error;
  }
};
export const getGateCombo = async (text = null) => {
  try {
    const url = generateApiUrl(["globalServices", "gate_combo"], [], {
      search_txt: text,
    });
    const response = await httpService.get(url);
    const data = pathOr([], ["data", "data"], response);
    const options = data.map((option) => {
      const { code, caption } = option;
      return { id: code, caption };
    });
    return { options };
  } catch (error) {
    throw error;
  }
};
export const getAssessorCombo = async (centerExecuteId, queryString) => {
  try {
    const url = generateApiUrl(
      ["globalServices", "assessor_combo"],
      [centerExecuteId],
      queryString
    );
    const response = await httpService.get(url);
    const data = pathOr([], ["data", "data"], response);
    const options = data.map((option) => {
      const name = pathOr("", ["parvandeh", "person", "name"], option);
      const family = pathOr("", ["parvandeh", "person", "family"], option);
      const code = pathOr("", ["person_center_execute_code"], option);
      return {
        caption: `${generateLang(["assessor"])} ${code} - ${name} ${family}`,
        id: pathOr(null, ["parvandeh", "code"], option),
      };
    });
    return { options };
  } catch (error) {
    throw error;
  }
};
export const getAssessmentPlanCombo = async (
  templateId,
  text = null,
  hasPlan = true
) => {
  try {
    const url = generateApiUrl(["globalServices", "assessmentPlanCombo"], [], {
      template_id: templateId,
      has_plan: hasPlan,
      search_txt: text,
    });
    const response = await httpService.get(url);
    const data = pathOr([], ["data", "data"], response);
    const options = data.map((option) => {
      return {
        id: pathOr(null, ["id"], option),
        caption: pathOr("", ["name"], option),
      };
    });
    return { options };
  } catch (error) {
    throw error;
  }
};
export const getTemplateCombo = async (queryString) => {
  try {
    const url = generateApiUrl(
      ["globalServices", "templateCombo"],
      [],
      queryString
    );
    const response = await httpService.get(url);
    const data = pathOr([], ["data", "data"], response);
    const options = data.map((option) => {
      return {
        id: pathOr(null, ["id"], option),
        caption: pathOr("", ["caption"], option),
      };
    });
    return { options };
  } catch (error) {
    throw error;
  }
};
export const getExecutivesCombo = async (
  text = null,
  extraQueryString = null
) => {
  try {
    let url = generateApiUrl(["globalServices", "executivesCombo"], [], {
      search_txt: text,
    });

    if (extraQueryString) {
      url += extraQueryString;
    }
    const response = await httpService.get(url);
    const data = pathOr([], ["data", "data"], response);
    const options = data.map((option) => {
      const parvandeh = pathOr(null, ["parvandeh"], option);
      const nationalCode = pathOr("", ["person", "national_code"], parvandeh);
      const personName = pathOr("", ["person", "name"], parvandeh);
      const termCaption = pathOr("", ["term", "caption"], parvandeh);
      return {
        id: pathOr(null, ["code"], parvandeh),
        caption: `${nationalCode} - ${personName} - ${termCaption}`,
      };
    });
    return { options };
  } catch (error) {
    throw error;
  }
};
export const getTermParvandehCombo = async (termCode, text = null) => {
  try {
    const url = generateApiUrl(
      ["globalServices", "termParvandehCombo"],
      [termCode],
      {
        search_txt: text,
      }
    );
    const response = await httpService.get(url);
    const data = pathOr([], ["data", "data"], response);
    const options = data.map((option) => {
      const parvandeh = pathOr(null, ["parvandeh"], option);
      const parvandehNumber = pathOr("", ["parvandeh_number"], parvandeh);
      const name = pathOr("", ["person", "name"], parvandeh);
      const family = pathOr("", ["person", "family"], parvandeh);
      const termCaption = pathOr("", ["term", "caption"], parvandeh);
      return {
        id: pathOr(null, ["code"], parvandeh),
        caption: `${parvandehNumber} - ${name} ${family} - ${termCaption}`,
      };
    });
    return { options };
  } catch (error) {
    throw error;
  }
};
export const getActionCombo = async (text = null, extraQueryString = {}) => {
  try {
    const url = generateApiUrl(["globalServices", "action"], [], {
      search_txt: text,
      ...extraQueryString,
    });
    const response = await httpService.get(url);
    const data = pathOr([], ["data", "data"], response);
    const options = data.map((option) => {
      return {
        id: pathOr(null, ["id"], option),
        caption: pathOr("", ["caption"], option),
      };
    });
    return { options };
  } catch (error) {
    throw error;
  }
};
export const getParvandehCombo = async (text = null, extraQueryString = {}) => {
  try {
    const url = generateApiUrl(["globalServices", "parvandehCombo"], [], {
      search_txt: text,
      ...extraQueryString,
    });
    const response = await httpService.get(url);
    const data = pathOr([], ["data", "data"], response);
    const options = data.map((option) => {
      const parvandehNumber = pathOr("", ["parvandeh_number"], option);
      const nationalCode = pathOr("", ["person", "national_code"], option);
      const name = pathOr("", ["person", "name"], option);
      const family = pathOr("", ["person", "family"], option);
      const termCaption = pathOr("", ["term", "caption"], option);
      const captionList = [
        parvandehNumber,
        `${name} ${family}`,
        nationalCode,
        termCaption,
      ];
      return {
        id: pathOr(null, ["parvandeh_code"], option),
        caption: captionList.filter(Boolean).join(" - "),
      };
    });
    return { options };
  } catch (error) {
    throw error;
  }
};
export const getParvandehWithNationalCodeCombo = async (
  text = null,
  extraQueryString = {}
) => {
  try {
    let url = generateApiUrl(
      ["globalServices", "parvandehWithNationalCodeCombo"],
      [],
      {
        search_txt: text,
        ...extraQueryString,
      }
    );
    const response = await httpService.get(url);
    const data = pathOr([], ["data", "data"], response);
    const options = data.map((option) => {
      const nationalCode = pathOr("", ["person", "national_code"], option);
      const name = pathOr("", ["person", "name"], option);
      const family = pathOr("", ["person", "family"], option);
      const termCaption = pathOr("", ["term", "caption"], option);
      return {
        id: pathOr(null, ["parvandeh_code"], option),
        caption: `${nationalCode} - ${name} ${family} - ${termCaption}`,
      };
    });
    return { options };
  } catch (error) {
    throw error;
  }
};
export const getExecutivesWithNationalCode = async (
  text = null,
  extraQueryString = {}
) => {
  try {
    let url = generateApiUrl(
      ["globalServices", "executivesWithNationalCode"],
      [],
      {
        search_txt: text,
      }
    );
    url += extraQueryString;
    const response = await httpService.get(url);
    const data = pathOr([], ["data", "data"], response);
    const options = data.map((option) => {
      const parvandeh = pathOr(null, ["parvandeh"], option);
      const nationalCode = pathOr("", ["person", "national_code"], parvandeh);
      const personName = pathOr("", ["person", "name"], parvandeh);
      const termCaption = pathOr("", ["term", "caption"], parvandeh);
      return {
        id: pathOr(null, ["code"], parvandeh),
        caption: `${nationalCode} - ${personName} - ${termCaption}`,
      };
    });
    return { options };
  } catch (error) {
    throw error;
  }
};
export const getCenterExecuteCombo = async (
  text = null,
  centerExecuteStatus = null
) => {
  try {
    const url = generateApiUrl(["globalServices", "centerExecuteCombo"], [], {
      search_txt: text,
      center_execute_status: centerExecuteStatus,
    });
    const response = await httpService.get(url);
    const data = pathOr([], ["data", "data"], response);
    const options = data.map((option) => {
      const id = pathOr(null, ["id"], option);
      const code = pathOr(null, ["code"], option);
      const caption = pathOr("", ["caption"], option);
      const startDate = pathOr("", ["start_date", "jalali"], option);

      return {
        id: code,
        caption: `${id} | ${caption} | ${startDate}`,
      };
    });
    return { options };
  } catch (error) {
    throw error;
  }
};
export const getTemplateExerciseCombo = async (templateId, text = null) => {
  try {
    const url = generateApiUrl(
      ["globalServices", "templateExerciseCombo"],
      [templateId],
      {
        search_txt: text,
      }
    );
    const response = await httpService.get(url);
    const data = pathOr([], ["data", "data"], response);
    const options = data.map((option) => {
      const { id, caption } = option;
      // TODO: remove value, text keys after redesign assessmentPlanPseudoData component
      return { id, caption, value: id, text: `${id}- ${caption}` };
    });
    return { options };
  } catch (error) {
    throw error;
  }
};
export const getExamPackCombo = async (text = null) => {
  try {
    const url = generateApiUrl(["globalServices", "examPackCombo"], [], {
      search_txt: text,
    });
    const response = await httpService.get(url);
    const data = pathOr([], ["data", "data"], response);
    const options = data.map((option) => {
      const { id, exam_pack_name: caption } = option;
      // TODO: remove value, text keys after redesign assessmentPlanPseudoData component
      return { id, caption, value: id, text: `${id}- ${caption}` };
    });
    return { options };
  } catch (error) {
    throw error;
  }
};
export const getCandidateCombo = async (text = null, extraQueryString = {}) => {
  try {
    const url = generateApiUrl(["globalServices", "candidatesCombo"], [], {
      search_txt: text,
      ...extraQueryString,
    });
    const response = await httpService.get(url);
    const data = pathOr([], ["data", "data"], response);
    const options = data.map((option) => {
      const nationalCode = pathOr("", ["person", "national_code"], option);
      const name = pathOr("", ["person", "name"], option);
      const family = pathOr("", ["person", "family"], option);
      const termCaption = pathOr("", ["term", "caption"], option);
      return {
        id: pathOr(null, ["parvandeh_code"], option),
        caption: `${nationalCode} - ${name} ${family} - ${termCaption}`,
      };
    });
    return { options };
  } catch (error) {
    throw error;
  }
};
export const getIndicatorCategoryCombo = async (text = null) => {
  try {
    const url = generateApiUrl(
      ["globalServices", "indicatorCategoryCombo"],
      [],
      {
        search_txt: text,
      }
    );
    const response = await httpService.get(url);
    const data = pathOr([], ["data", "data"], response);
    const options = data.map(({ id, name: caption, value }) => {
      return { id, caption, value };
    });
    return { options };
  } catch (error) {
    throw error;
  }
};
